import { useState } from 'react'
import { ErroreApi } from '../servizi/api.ts'
import { sblocca, sfidaSblocco } from '../servizi/accesso-ricordato.ts'
import { useSessione } from '../servizi/sessione.tsx'
import { Attesa, Avviso } from './Pezzi.tsx'
import { Bottone } from './base.tsx'

/**
 * Sblocco della web app dell'iPhone ricordata (521): copre il gestionale all'apertura e dopo cinque
 * minuti in secondo piano, finche' Face ID (o il codice dell'iPhone) non firma la sfida. La sfida arriva
 * prima del tocco: Safari apre Face ID solo dal gesto della persona, senza attese in mezzo.
 */
export function SbloccoTelefono() {
  const { sblocco, sbloccato, entraConPassword } = useSessione()
  const [errore, setErrore] = useState<string | null>(null)
  const [inCorso, setInCorso] = useState(false)
  const [opzioni, setOpzioni] = useState(sblocco)
  const correnti = opzioni ?? sblocco

  async function prova() {
    if (!correnti) return
    setErrore(null); setInCorso(true)
    try {
      await sblocca(correnti)
      await sbloccato()
    } catch (e) {
      setErrore(e instanceof ErroreApi ? e.message : 'Sblocco annullato: riprova.')
      // La sfida vale una volta: se ne prepara un'altra per il prossimo tocco.
      try { setOpzioni(await sfidaSblocco()) } catch { setOpzioni(null) }
    } finally {
      setInCorso(false)
    }
  }

  return (
    <div className="accesso">
      <div className="riquadro">
        <div className="scheda">
          <div className="stemma">
            <img src="/immagini/cidis-logo.png" alt="C.I.D.I.S. Impresa Sociale ETS" />
          </div>
          <h1>Gestionale CIDIS</h1>
          <p className="occhiello">Sblocca per continuare</p>
          {errore && <Avviso tipo="errore">{errore}</Avviso>}
          {correnti ? (
            <Bottone variante="primario" larghezzaPiena inCorso={inCorso} onClick={() => { void prova() }}>
              Sblocca con Face ID
            </Bottone>
          ) : <Attesa testo="Un momento…" />}
          <p className="accesso-nota">Se Face ID non riesce, l’iPhone chiede il suo codice.</p>
          <div className="accesso-uscita">
            <Bottone variante="discreto" larghezzaPiena onClick={entraConPassword}>
              Entra con nome utente e password
            </Bottone>
          </div>
        </div>
      </div>
    </div>
  )
}
